import React, { useCallback, useEffect, useState } from 'react';
import Package from '../../assets/images/package.svg';
import './ConfirmationFreeView.css';
import { useLanguage } from '../../locale/useLanguage';
import { useHistory, useLocation } from 'react-router-dom';
import { Routes } from '../../routes/types';
import dayjs from 'dayjs';
import { EndFlowScreen } from '../../components/EndFlowScreen/EndFlowScreen';

type ConfirmationFreeViewProps = {};

type ConfirmationFreeViewRouteParams = {
  range: string;
  address: string;
};

export const ConfirmationFreeView: React.FC<ConfirmationFreeViewProps> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const location = useLocation<ConfirmationFreeViewRouteParams>();
  const [content, setContent] = useState<Array<{ [key: string]: string }>>([]);
  const [button, setButton] = useState<{ text: string; onClick: () => void }>();

  const goToTracking = useCallback(() => {
    history.push(Routes.Home);
  }, [history]);

  useEffect(() => {
    if (!location.state) {
      history.replace(Routes.Home);
    } else {
      let days = location.state.range.split('/');
      let day = dayjs(days[0]).format('dddd, D MMMM YYYY');
      let from = dayjs(days[0]).format('HH:mm');
      let to = dayjs(days[1]).format('HH:mm');
      setContent([
        {
          title: t('confirmationFree.range'),
          label: `${day}
      ${from} - ${to}`,
        },
        {
          title: t('confirmationFree.address'),
          label: location.state?.address,
        },
      ]);
      setButton({
        text: t('paymentSuccess.trackOrder'),
        onClick: goToTracking,
      });
    }
  }, [goToTracking, history, location.state, t]);

  return (
    <EndFlowScreen
      image={Package}
      buttonPrimary={button}
      title={t('confirmationFree.title')}
      content={content}
    />
  );
};
